import React, { FunctionComponent } from "react";

type Dimensions = {
  height: number;
  width: number;
};

type Coordinates = {
  x: number;
  y: number;
};

type Data = {
  isActive: boolean;
}

export const BlackKey: FunctionComponent<Dimensions & Coordinates & Data> = ({ height, width, x, y, isActive }) => (
  <svg
    fill="none"
    viewBox="0 0 31 213"
    preserveAspectRatio="none"
    // preserveAspectRatio="xMinYMin meet"
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    x={x}
    y={y}
  >
    <path
      d="M0.5 0.5H30.5V210C30.5 211.381 29.3807 212.5 28 212.5H3C1.61929 212.5 0.5 211.381 0.5 210V0.5Z"
      fill="white"
    />
    <g opacity={isActive ? 1 : 0.3}>
      <path
        d="M0.5 0.5H30.5V210C30.5 211.381 29.3807 212.5 28 212.5H3C1.61929 212.5 0.5 211.381 0.5 210V0.5Z"
        fill="black"
      />
      <path
        d="M0.5 0.5H30.5V210C30.5 211.381 29.3807 212.5 28 212.5H3C1.61929 212.5 0.5 211.381 0.5 210V0.5Z"
        fill="url(#paint0_linear)"
        fillOpacity="0.69"
      />
      <path
        d="M0.5 0.5H30.5V210C30.5 211.381 29.3807 212.5 28 212.5H3C1.61929 212.5 0.5 211.381 0.5 210V0.5Z"
        stroke="#8D8D8D"
      />
      <path
        d="M1 0H31V209C31 210.657 29.6569 212 28 212H4C2.34315 212 1 210.657 1 209V0Z"
        fill="black"
      />
      <path
        d="M1 0H31V209C31 210.657 29.6569 212 28 212H4C2.34315 212 1 210.657 1 209V0Z"
        fill="url(#paint1_linear)"
        fillOpacity="0.69"
      />
      <path
        d="M6 0H26V202C26 204.761 23.7614 207 21 207H11C8.23858 207 6 204.761 6 202V0Z"
        fill="black"
      />
      <path
        d="M6 0H26V202C26 204.761 23.7614 207 21 207H11C8.23858 207 6 204.761 6 202V0Z"
        fill="url(#paint2_linear)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="2.23239e-07"
        y1="90.4245"
        x2="40.8167"
        y2="90.4245"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.276042" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="1"
        y1="90"
        x2="40.5"
        y2="90"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.276042" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear"
        x1="16"
        y1="-38.1845"
        x2="16"
        y2="194.942"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const WhiteKey: FunctionComponent<Dimensions & Coordinates & Data> = ({ height, width, x, y, isActive }) => (
  <svg
    fill="none"
    height={height}
    // preserveAspectRatio="xMinYMin meet"
    preserveAspectRatio="none"
    viewBox="0 0 57 357"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    x={x}
    y={y}
  >
    <rect x="0.5" y="0.5" width="56" height="356" fill={isActive ? 'white' : '#ccc'} />
    <rect x="0.5" y="0.5" width="56" height="356" fill="url(#paint0_linear)" />
    <rect x="0.5" y="0.5" width="56" height="356" fill="url(#paint1_linear)" />
    <rect x="0.5" y="0.5" width="56" height="356" stroke="#434343" />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="28"
        y1="-75.5"
        x2="28"
        y2="378.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F0F0F0" />
        <stop offset="1" stopColor="#E1E1E1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="37"
        y1="-6.5"
        x2="37"
        y2="363.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="0.0320731" stopColor="#DBDBDB" stopOpacity="0.232893" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

interface KeyProps {
  data: {
    colour: 'black' | 'white';
    isActive: boolean;
  };
  height: number;
  width: number;
  x: number;
  y: number;
}

const Key: FunctionComponent<KeyProps> = ({data, ...rest}) => {
  const KeyComponent = data.colour === 'black' ? BlackKey : WhiteKey;

  return <KeyComponent isActive={data.isActive} {...rest} />;
}

export default Key;
